export const onlyDigits = (v) => /^\d+$/.test(v);

export const normalizeSpaces = (s = '') => s.trim().replace(/\s+/g, ' ');

// Detecta: "aaaaaa", "adadadad", "sooo", etc.
export const looksLikeGibberish = (s = '') => {
  const str = normalizeSpaces(s).toLowerCase();
  if (str.length < 2) return true;

  const compact = str.replace(/\s/g, '');
  if (/^(.)\1{3,}$/.test(compact)) return true;     // aaaa
  if (/^(.{2})\1{2,}$/.test(compact)) return true;  // adadad
  if (/(.)\1\1/.test(compact)) return true;         // sooo

  return false;
};

export const validHumanName = (s = '') => {
  const str = normalizeSpaces(s);

  // letras + espacios (incluye tildes/ñ)
  if (!/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]+$/.test(str)) return false;

  const letters = str.replace(/\s/g, '');
  if (letters.length < 2) return false;

  if (looksLikeGibberish(str)) return false;

  return true;
};

// ✅ Validador listo para tu formulario
export const validateCliente = (formData) => {
  const identificacion = (formData.identificacion || '').trim();
  const whatsapp = (formData.whatsapp_number || '').trim();
  const nombres = formData.nombres || '';
  const apellidos = formData.apellidos || '';

  if (!onlyDigits(identificacion)) return 'Identificación: solo números';
  if (whatsapp && !onlyDigits(whatsapp)) return 'WhatsApp: solo números';

  if (whatsapp && identificacion === whatsapp)
    return 'Identificación y WhatsApp no pueden ser iguales';

  if (!validHumanName(nombres)) return 'Nombres inválidos (mín. 2 letras)';
  if (!validHumanName(apellidos)) return 'Apellidos inválidos (mín. 2 letras)';

  return null; // ✅ todo ok
};
